import makeStorage from "./makeStorage";

const useLocalStorage = makeStorage(localStorage);

export default useLocalStorage;
